import {
    Eye,
    CircleDot,
    Glasses,
    Activity,
    Baby,
    ScanEye,
    Stethoscope,
} from "lucide-react";

export const CLINIC = {
    name: "Optiplus",
    tagline: "Ophthalmology Clinic & Optician",
    phoneDisplay: "098303 10481",
    phoneHref: "tel:+919830310481",
    phoneDisplay2: "033-2411-04811",
    phoneHref2: "tel:03324110481",
    email: "optiplus@rediffmail.com",
    emailHref: "mailto:optiplus@rediffmail.com",
    whatsapp:
        "https://wa.me/919831046009?text=Hello%20Optiplus!%20I%27d%20like%20to%20book%20an%20eye%20exam.",
    address:
        "1/69, beside Shakti Sangha Club, Naktala, Kolkata, West Bengal 700047",
    addressShort: "Naktala, Kolkata",
    hours: "Mon – Sat · 9:00 AM – 10:00 PM",
    sunday: "Sunday · Closed",
    rating: "4.4",
    reviewCount: "8",
    googleProfile: "https://share.google/ZKPBktBayOd1pV5qq",
    mapEmbed:
        "https://www.google.com/maps?q=Optiplus,+Naktala,+Kolkata,+West+Bengal+700047&output=embed",
};

export const NAV_LINKS = [
    { label: "Home", to: "/", testId: "nav-link-home" },
    { label: "About Us", to: "/about", testId: "nav-link-about" },
    { label: "Our Remedy", to: "/remedy", testId: "nav-link-remedy" },
    { label: "Contact Us", to: "/contact", testId: "nav-link-contact" },
];

export const MARQUEE_ITEMS = [
    "Comprehensive Eye Exams",
    "Contact Lens Fittings",
    "Eyewear Prescriptions",
    "Surgical Procedures",
    "4.4★ on Google",
    "Most Major Insurances Accepted",
];

export const SERVICES = [
    {
        icon: Eye,
        title: "Comprehensive Eye Exam",
        desc: "A complete vision work-up — computerised refraction, slit-lamp evaluation and a precise prescription, all in one relaxed sitting.",
        testId: "service-comprehensive-exam",
    },
    {
        icon: CircleDot,
        title: "Contact Lens Fitting",
        desc: "Corneal measurements, trial lenses and wear training so your lenses feel invisible from day one.",
        testId: "service-contact-lens-fitting",
    },
    {
        icon: Glasses,
        title: "Eyewear & Prescriptions",
        desc: "Curated frames matched to your face and lifestyle, fitted with precision lenses crafted to your exact prescription.",
        testId: "service-eyewear-prescription",
    },
    {
        icon: Activity,
        title: "Surgical Procedures",
        desc: "Consultation, planning and post-operative care for cataract and other ophthalmic surgeries, guided end to end.",
        testId: "service-surgical-procedures",
    },
    {
        icon: Baby,
        title: "Pediatric Eye Care",
        desc: "Gentle, patient-first examinations for children — early detection of squint, lazy eye and refractive errors.",
        testId: "service-pediatric-eye-care",
    },
    {
        icon: ScanEye,
        title: "Glaucoma & Cataract Evaluation",
        desc: "Eye-pressure checks, optic nerve assessment and lens screening to catch silent conditions before they advance.",
        testId: "service-glaucoma-cataract-eval",
    },
];

export const DISCIPLINES = [
    "Ophthalmology Unit",
    "Optometry Unit",
    "Comprehensive Eye Examination",
    "Retina, Glaucoma and Cataract Evaluation & Management",
    "Myopia Management",
    "Neuro Optometric Rehabilitation",
    "Advance Vision Therapy",
    "Advance Contact Lens",
    "Low Vision Aid",
    "Artificial Eye",
    "Optical Unit",
];

export const REMEDY_GROUPS = [
    {
        icon: Eye,
        title: "Comprehensive Eye Examination",
        bullets: [
            "Slit Lamp Biomicroscopy",
            "Indirect/Direct Ophthalmoscopy",
            "Refractometry (Objective) by Static/Dynamic Retinoscope, Refractometry (Objective) by Auto-Refractometer, Subjective Refractometry",
            "Color Vision/Depth Perception",
            "Tonometry (Intraocular Pressure)",
            "Binocular Vision Assessment and Remedy",
            "Keratometry/Topography (Cornea)",
        ],
        testId: "remedy-comprehensive-eye-exam",
    },
    {
        icon: CircleDot,
        title: "Contact Lens Clinic",
        bullets: ["World best RGP, Soft Contact Lens, CRT Lens, Scleral Lens"],
        testId: "remedy-contact-lens-clinic",
    },
    {
        icon: ScanEye,
        title: "Evaluation and Management",
        bullets: ["Retina, Glaucoma, Corneal, Vitreous, Cataract, Pediatric Eye"],
        testId: "remedy-evaluation-management",
    },
    {
        icon: Activity,
        title: "Speciality Clinic",
        bullets: [
            "Myopia Management (Peripheral Defocus, Orthokeratology)",
            "Vision Therapy",
            "Neuro Optometric Rehabilitation",
            "Binocular Vision Assessment and Remedy",
            "Low Vision Aid & Artificial Eye",
            "Headache, Eye Strain, Dry Eye Syndrome, Xerophthalmia",
        ],
        testId: "remedy-speciality-clinic",
    },
    {
        icon: Stethoscope,
        title: "Surgical Procedures",
        bullets: [
            "Consultation, Pre and Post-Operative care for cataract and other ophthalmic surgeries — guided end to end",
        ],
        testId: "remedy-surgical-procedures",
    },
    {
        icon: Glasses,
        title: "Optical Unit",
        bullets: [
            "A wide range of Frames and Sunglasses",
            "Correct Ophthalmic Lenses",
            "World Best Contact Lenses and Solutions",
        ],
        testId: "remedy-optical-unit",
    },
];

export const TESTIMONIALS = [
    {
        name: "Soma Banerjee",
        area: "Naktala",
        quote: "The doctor took real time with my mother's cataract evaluation. No rushing, every question answered. Rare to find this patience today.",
        service: "Surgical Consultation",
        testId: "testimonial-card-1",
    },
    {
        name: "Rahul Chatterjee",
        area: "Netaji Nagar",
        quote: "Got my first contact lenses fitted here. They measured everything properly and taught me the whole routine. Zero discomfort since.",
        service: "Contact Lens Fitting",
        testId: "testimonial-card-2",
    },
    {
        name: "Priya Das",
        area: "Garia",
        quote: "Brought my 6-year-old for her first eye check. The team made it feel like a game, not a clinic visit. She's actually excited for the follow-up.",
        service: "Pediatric Eye Care",
        testId: "testimonial-card-3",
    },
    {
        name: "Anirban Mukherjee",
        area: "Tollygunge",
        quote: "Honest advice, fair pricing, and my progressive glasses were ready exactly when promised. This is my family's optician now.",
        service: "Eyewear Prescription",
        testId: "testimonial-card-4",
    },
];

export const PRACTITIONER = {
    name: "Dr. Sougata Chatterjee",
    role: "Consulting Optometrist",
    experience: "36+ years of experience",
    since: "Practicing at Optiplus since 1990",
    credentials: [
        "B.Optm — Hyderabad, 2007",
        "Diploma in Optometrical Science — University of Calcutta, 1990",
        "FAO — University of Calcutta, 1992",
        "FOAI — University of Calcutta, 1993",
    ],
};

export const GOOGLE_REVIEW = {
    quote: "Great service and friendly staff! Highly recommend for eye check-ups.",
    source: "Google review · Optiplus, Naktala",
};

export const IMAGES = {
    heroEye: "https://images.unsplash.com/photo-1483519173755-be893fab1f46?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    exam: "https://images.unsplash.com/photo-1758656321505-95bf802f9a4c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    consult: "https://images.unsplash.com/photo-1766310549795-dd0fc75d499f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    eyewear: "https://images.unsplash.com/photo-1524255684952-d7185b509571?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    frames: "https://images.unsplash.com/photo-1603578119639-798b8413d8d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};
